document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const widget = document.querySelector('.es-embed-root');

    if (!widget || !widget.shadowRoot) return;

    // Remove Elfsight links
    widget.shadowRoot.querySelectorAll('a').forEach(a => {
      if (a.href.includes('elfsight')) {
        a.remove();
      }
    });

    // Apply styles
    const mainContainer = widget.shadowRoot.querySelector('.es-main-container');
    const badgeContainer = widget.shadowRoot.querySelector('.es-badge-container');

    if (mainContainer) {
      mainContainer.style.setProperty('width', 'unset', 'important');
      mainContainer.style.setProperty('max-width', 'unset', 'important');
    }

    if (badgeContainer) {
      badgeContainer.style.setProperty('margin', '0', 'important');
    }

    clearInterval(interval);
  }, 500);
});